import React, { useContext } from 'react'
import { Layers, Home, User, Circle } from 'react-feather';
import { AbilityContext } from '../../utility/context/Can';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';

export default function vertical() {
  const ability = useContext(AbilityContext)

  const array = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      icon: <Home size={20} />,
      navLink: '/dashboard'
    },
    {
      id: 'events',
      title: 'Eventos',
      icon: <Layers size={20} />,
      navLink: '/events'
    },
    (ability.can('Manage', 'All') ? {
      id: 'roles&permissions',
      title: 'Roles Y Permisos',
      icon: <AdminPanelSettingsOutlinedIcon size={20} />,
      navLink: '/roles&permissions'
    } : {}),
    (ability.can('Manage', 'All') ? {
      id: 'users',
      title: 'Usuarios',
      icon: <User size={20} />,
      navLink: '/users'
    } : {}),
    (ability.can('Manage', 'All') ? {
      id: 'deposits',
      title: 'Depósitos',
      icon: <PriceChangeOutlinedIcon fontSize='large'/>,
      navLink: '/users',
      children: [
        (ability.can('Read', 'Information') || ability.can('Manage', 'All') ? {
          id: "deposit",
          title: "Realizar depósitos",
          icon: <Circle />,
          navLink: `/deposit`,
          action: "read",
          resource: "landing",
        } : { disabled: true }),
        (ability.can('Read', 'Information') || ability.can('Manage', 'All') ? {
          id: "list",
          title: "Listado",
          icon: <Circle />,
          navLink: `/payments`,
          action: "read",
          resource: "landing",
        } : { disabled: true })
      ]
    } : {}),
  ]

  return array;
}